import React from 'react'
import AdminHeader from '../../components/adminComponents/adminHeaderSidebarTitleComponents/AdminHeader'
import AdminSidebar from '../../components/adminComponents/adminHeaderSidebarTitleComponents/AdminSidebar'
import ViewAllNotifications from '../../components/adminComponents/adminHeaderSidebarTitleComponents/ViewAllNotifications'

const AdminNotificationsPage = () => {
    return (
        <>
            <AdminHeader />
            <AdminSidebar />
            <div className="body-wrapper clearfix">
                <section className="main-container " id="fullscreen">
                    <div className="px-4 py-2 border-top-0 emp-dashboard">
                        <div className="d-block d-lg-flex d-md-flex justify-content-between action-bar mb-20 mt-3">
                            <div
                                id="table-actions"
                                className="flex-grow-1 align-items-center"
                            >
                                <h4 className=" mb-0 f-21 text-capitalize font-weight-bold">
                                    {" "}
                                    Notifications{" "}
                                </h4>
                            </div>
                            <div
                                className="btn-group mt-2 mt-lg-0 mt-md-0 ml-0 ml-lg-3 ml-md-3"
                                role="group"
                            >
                                {/* <NavLink
                                    to="/compose-message"
                                    type="button"
                                    className="btn-secondary rounded f-14 p-2 mr-3 float-left mb-2 mb-lg-0 mb-md-0"
                                    id="add-lead"
                                >
                                    Compose Message
                                </NavLink> */}
                            </div>
                        </div>
                        <ViewAllNotifications />
                    </div>
                </section>
            </div>
        </>
    )
}
export default AdminNotificationsPage